let data = {
    "User": "Matthew N. Ishii",
    "Loc": "Los Altos, CA",
    "Title": "Software Engineer",
    "Photo": "../images/profilepic.jpg",
    "ProjectLink": "http://mishiitech.com/Projects/",
    "GitHubLink": "http://www.github.com/mattishii26",
    "AboutMe": `Product driven Software Engineer
    who aims to develop modular and testable solutions.<br/>
    Check out my <a href="../Projects">Projects</a>!
    `,
    "DetailedAboutMe": `I am a Software Engineer who has successfully delivered multiple projects in an Agile Environment, as a Technical Lead, Front End Developer, and Full Stack Developer! I enjoy collaborating closely with a team to overcome the challenges of development. As a developer, I have a strong background of developing solutions to optimize workflow for the operations of finance and asset management.`,
    "Technologies": {
        "Database": [ "MongoDB", "MicrosoftSQL", "MySQL"],
        "Languages": ["JavaScript (ES6)", "Python", "C#"],
        "Frameworks": ["ReactJS", "ExpressJS", "NodeJS", ".NET Core 2.1", "Angular 8"],
    },
    "socialLinks":[
         {
            "name":"linkedin",
            "url":"https://www.linkedin.com/in/matthew-ishii-b1b31499/",
            "className":"fab fa-linkedin-in fa-2x"
          },
          {
            "name":"github",
            "url":"https://github.com/mattishii26",
            "className":"fab fa-github fa-2x"
          },
    ],
    "Projects": [
      
    ]
}

export default data;